import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import Proof from "@/pages/Proof";
import { useMediaProtection } from "@/lib/useMediaProtection";
import "@/App.css";

export default function App() {
  useMediaProtection();
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/proof/:code" element={<Proof />} />
      </Routes>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#101014",
            border: "1px solid #282830",
            color: "#F7F4EE",
            fontFamily: "'JetBrains Mono', monospace",
            fontSize: "12px",
            borderRadius: "2px",
          },
        }}
      />
    </BrowserRouter>
  );
}
